import Container from 'react-bootstrap/Container'
import Typography from '../../../Typography/Typography'

import './LogoSocials.scss'

const WEB_PORTAL_URL = process.env.REACT_APP_WEB_PORTAL_URL

const LogoSocials = () => {
    return (
        <Container fluid className={'logo-socials d-flex'}>
            <img
                src={'images/logo/logo-blue.svg'}
                alt={'CineStar Logo'}
                role={'button'}
                onClick={() => (window.location = `${WEB_PORTAL_URL}`)}
            />
            <div className="logo-socials__contentApp d-flex flex-column">
                <Typography variant={'label'} color={'lighterPrimary'} className={'logo-socials__content--watch'}>
                    {'Stahujte mobilní plikaci'}
                </Typography>
                <div className="d-flex gap-3 align-items-center pt-5">
                    <a href="https://apps.apple.com/cz/app/cinestar/id6476278135?l=cs">
                        <img src={'images/icons/appleApp.png'} alt={'CineStar Facebook'} />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=cz.cinestar.app&hl=cs">
                        <img src={'images/icons/androidApp.png'} alt={'CineStar Instagram'} />
                    </a>
                </div>
            </div>
            <div className="logo-socials__content d-flex flex-column">
                <Typography variant={'label'} color={'lighterPrimary'} className={'logo-socials__content--watch'}>
                    {'Sledujte nás'}
                </Typography>
                <div className="logo-socials__content--icons d-flex  align-items-center">
                    <a href="https://www.facebook.com/cinestar.cz/">
                        <img src={'images/icons/fb.svg'} alt={'CineStar Facebook'} />
                    </a>
                    <a href="https://www.instagram.com/cinestar_cz/?hl=cs">
                        <img src={'images/icons/instagram.svg'} alt={'CineStar Instagram'} />
                    </a>
                    <a href="https://www.youtube.com/channel/UCROI_hpbi75Gx7Y7EcIHqjw/feed">
                        <img src={'images/icons/youtube.svg'} alt={'CineStar YouTube'} />
                    </a>

                    <a href="https://www.tiktok.com/@cinestar_cz">
                        <img src={'images/icons/tiktok.svg'} alt={'CineStar Tiktok'} />
                    </a>
                </div>
            </div>
        </Container>
    )
}

export default LogoSocials
